export const encodeCarData = (data: Object) => {
  let prefix = ''
  const possible = 'abcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < 3; i++) {
    const char = Math.floor(Math.random() * possible.length)
    prefix += possible.charAt(char)
  }

  return prefix + btoa(escape(JSON.stringify({ ...data })))
}
